// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyA5noD0XMZ_gMrAp9qT6WXPia61d6Duv_k",
  authDomain: "woodball-uganda.firebaseapp.com",
  projectId: "woodball-uganda",
  storageBucket: "woodball-uganda.firebasestorage.app",
  messagingSenderId: "250750405655",
  appId: "1:250750405655:web:129c674f4c25d399ca2052"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };